var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.89258V8.23633",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69103 2.3439L1.53478 11.2501C1.45264 11.3924 1.40933 11.5538 1.40918 11.7181C1.40903 11.8824 1.45206 12.0438 1.53396 12.1862C1.61585 12.3286 1.73373 12.447 1.87579 12.5296C2.01784 12.6121 2.17909 12.6558 2.34338 12.6564H12.6559C12.8202 12.6558 12.9814 12.6121 13.1235 12.5296C13.2655 12.447 13.3834 12.3286 13.4653 12.1862C13.5472 12.0438 13.5902 11.8824 13.5901 11.7181C13.5899 11.5538 13.5466 11.3924 13.4645 11.2501L8.30822 2.3439C8.22669 2.20144 8.10898 2.08305 7.96698 2.00071C7.82499 1.91837 7.66377 1.875 7.49963 1.875C7.33549 1.875 7.17426 1.91837 7.03227 2.00071C6.89028 2.08305 6.77256 2.20144 6.69103 2.3439V2.3439Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.1523C7.91421 11.1523 8.25 10.8166 8.25 10.4023C8.25 9.98813 7.91421 9.65234 7.5 9.65234C7.08579 9.65234 6.75 9.98813 6.75 10.4023C6.75 10.8166 7.08579 11.1523 7.5 11.1523Z",
    fill: "#999999"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6dc1ad33461e718fe15f55c898836f02.svg";
export { ForwardRef as ReactComponent };